import React from "react";
import { Box, styled } from "@mui/material";
import ChatListTopBar from "./section/chat-list-top-bar";
import ChatListItems from "./section/chat-list-items";

const StyledContainer = styled(Box)(({ theme }) => ({
  flex: 1,
  borderRight: `1px solid ${theme.palette.grey.A400}`,
}));

const ChatList = () => {
  return (
    <StyledContainer>
      <ChatListTopBar />
      <ChatListItems />
    </StyledContainer>
  );
};

export default ChatList;
